package org.hs_soft.runmynesto.domain.model.home.options

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class MenuCardEnum(
    val key: String
) {
    Selected(
        key = "Selected"
    ),
    Name(
        key = "Name"
    ),
    Description(
        key = "Description"
    ),
    Price(
        key = "Price"
    ),
    Weight(
        key = "Weight"
    ),
    Allergens(
        key = "Allergens"
    ),
    Category(
        key = "Category"
    ),
    TurnoverGroup(
        key = "TurnoverGroup"
    ),
//    Template(
//        key = "Template"
//    ),
    Ingredients(
        key = "Ingredients"
    ),
    ProductNumber(
        key = "ProductNumber"
    ),
    Kuchen(
        key = "Kuchen"
    ),
    Buffet(
        key = "Buffet"
    ),
    Alcoholic(
        key = "Alcoholic"
    ),
    Vegetarian(
        key = "Vegetarian"
    ),
    Vegan(
        key = "Vegan"
    );


    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                Selected -> strings.selected
                Name -> strings.name
                Description -> strings.description
                Price -> strings.price
                Weight -> strings.weight
                Allergens -> strings.allergens
                Category -> strings.category
                TurnoverGroup -> strings.turnoverGroup
//                Template -> strings.template
                Ingredients -> strings.ingredients
                ProductNumber -> strings.productNumber
                Kuchen -> strings.kuchen
                Buffet -> strings.buffet
                Alcoholic -> strings.alcoholic
                Vegetarian -> strings.vegetarian
                Vegan -> strings.vegan
            }
        }
}